import { object, string } from 'yup'

import { i18nErrorCodes } from '../form-utils'
import { dniSchema, phoneSchema } from './formatSchemas'

const { required } = i18nErrorCodes

export default object().shape({
  name: string().required(required),
  surname: string().required(required),
  dni: dniSchema,
  birthday: string(),
  gender: string().required(required),
  phone: phoneSchema,
  mobile: phoneSchema.required(required),
})

export const emptyPersonalInfo = {
  name: '',
  surname: '',
  dni: '',
  birthday: '',
  gender: 'm',
  phone: '',
  mobile: '',
  photo: '',
}

export const convertPersonal = ({
  name,
  surname,
  dni,
  phone,
  mobile,
  birthday,
  gender,
  photo,
}) => ({
  personal: {
    name,
    surname,
    dni,
    phone,
    mobile,
    birthday: birthday == '' ? 0 : birthday,
    gender,
    photo,
  },
})



// WEBPACK FOOTER //
// ./src/components/forms/schemas/personal.schema.ts